<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	#recent-posts-1 ul li a {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	#post-82.post-82 .entry-header .entry-title a {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	/*事件日历部分*/
	
	.body .item .day-body {
		height: 228px;
		overflow-x: hidden;
		overflow-y: auto;
	}
	
	.body .item .day-body .activity {
		box-sizing: border-box;
		padding: 8px 5px;
		font-size: 13px;
		color: #64646E;
		line-height: 1.5;
		border-bottom: 1px solid #E9E9E9;
	}
	
	.body .item .day-body .activity:last-child {
		border-bottom: none;
	}
	
	.activity {
		display: block;
	}
	
	.activity .lay-title {
		font-size: 16px;
		text-indent: 2em;
		margin-bottom: 15px;
	}
	
	.lay-time {
		font-size: 14px;
		margin-bottom: 20px;
	}
	
	.lay-time div {
		margin-bottom: 10px;
	}
	
	.lay-time div i {
		margin-right: 10px;
	}
	
	.lay-img {
		margin-top: -10px;
		margin-bottom: 10px;
	}
	
	.lay-content {
		margin-bottom: 10px;
	}
	
	.lay-link {
		text-align: center;
		line-height: 30px;
	}
	/*事件日历部分-end*/
</style>


// WEBPACK FOOTER //
// src/App.vue